module.exports = __webpack_public_path__ + "img/login-v2.fc9f0786.svg";